export default __webpack_public_path__ + "847944bf5bb766141980fe539e8c4afe.png";